import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";

export interface TEvaluationBusinessRule {
  evaluationBusinessRuleId: number;
  evaluationBusinessRuleResult: string;
  evaluationBusinessRuleDifficultyFactor: number;
  errorLog: string;
  businessRule: number;
  businessRuleName: string;
  businessRuleDescription: string;
}

export interface IEvaluationBusinessRule extends TEvaluationBusinessRule {}

const EvaluationBusinessRule = Model(
  (model: TEvaluationBusinessRule): IEvaluationBusinessRule => {
    const _evaluationBusinessRule: TEvaluationBusinessRule = Object.assign(
      {},
      model
    );

    let create = (
      evaluationBusinessRule: IEvaluationBusinessRule
    ): IEvaluationBusinessRule => {
      let obj = ValidatableObject(evaluationBusinessRule);
      return obj;
    };

    let evaluationBusinessRule = {
      get evaluationBusinessRuleId() {
        return _evaluationBusinessRule.evaluationBusinessRuleId;
      },
      set evaluationBusinessRuleId(value) {
        _evaluationBusinessRule.evaluationBusinessRuleId = value;
      },
      get evaluationBusinessRuleResult() {
        return _evaluationBusinessRule.evaluationBusinessRuleResult;
      },
      set evaluationBusinessRuleResult(value) {
        _evaluationBusinessRule.evaluationBusinessRuleResult = value;
      },
      get evaluationBusinessRuleDifficultyFactor() {
        return _evaluationBusinessRule.evaluationBusinessRuleDifficultyFactor;
      },
      set evaluationBusinessRuleDifficultyFactor(value) {
        _evaluationBusinessRule.evaluationBusinessRuleDifficultyFactor = value;
      },
      get errorLog() {
        return _evaluationBusinessRule.errorLog;
      },
      set errorLog(value) {
        _evaluationBusinessRule.errorLog = value;
      },
      get businessRule() {
        return _evaluationBusinessRule.businessRule;
      },
      set businessRule(value) {
        _evaluationBusinessRule.businessRule = value;
      },
      get businessRuleName() {
        return _evaluationBusinessRule.businessRuleName;
      },
      set businessRuleName(value) {
        _evaluationBusinessRule.businessRuleName = value;
      },
      get businessRuleDescription() {
        return _evaluationBusinessRule.businessRuleDescription;
      },
      set businessRuleDescription(value) {
        _evaluationBusinessRule.businessRuleDescription = value;
      }
    };

    return create(evaluationBusinessRule);
  }
);

export default EvaluationBusinessRule;
